export default __webpack_public_path__ + "static/media/image-about-mission-w@2x.e89784e8.webp";